import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesRequeridosValidarComponent {
  data
  idProyecto
  guardando
  onChange
  onSelect

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.onChange({$event: {detail: this.data}})
  }

  actualizar () {
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('viaticosConfiguracionProyectoResponsablesRequeridosValidar', {
  controller: ViaticosConfiguracionProyectoResponsablesRequeridosValidarComponent,
  template,
  bindings: {
    data: '<',
    idProyecto: '<',
    guardando: '<',
    onChange: '&',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/requeridosValidar/component.js